import {SET_PAGES} from './pageActionTypes';

const initialState = []

export default function pageReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PAGES:
            return action.payload

        default:
            return state;
    }
}
